export default __webpack_public_path__ + "static/media/HistoricStatus.ec75d495.svg";